import type { IconData } from '@stacksjs/iconify-core'

export const musicNote2Solid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M44.572 4.87c0-1.928-1.563-3.504-3.523-3.372c-4.925.331-15.164 1.523-24.964 5.828c-1.918.843-3.069 2.771-3.069 4.834v15.794a9.456 9.456 0 1 0 7.298 9.895a.5.5 0 0 0 .024-.154V18.652A84.3 84.3 0 0 1 37.25 14.63v8.055a9.456 9.456 0 1 0 7.298 9.895a.5.5 0 0 0 .024-.154z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default musicNote2Solid
